import { createSelector } from 'reselect';
// On réutilise le slice productsSelector (déjà chargé au boot) et ses selectors.
import {
	getMenusList,
	getMenuSelected,
	getCategorySelected,
	getLoaded,
	parseCategoryByMenu,
	getProductsList,
} from '../../../../Containers/Partners/Components/ProductsSelector/Components/ProductsSelectorModal/selector';
import { ALL } from '../../../../Containers/Partners/Components/ProductsSelector/Components/ProductsSelectorModal/utils';

export {
	getMenusList,
	getMenuSelected,
	getCategorySelected,
	getLoaded,
	parseCategoryByMenu,
	getProductsList,
};

// Pseudo-catégories (id de catégorie réservés, distincts de ALL / 0 / vrais ids).
export const PSEUDO = { EXPORTS: '__EXPORTS__', UNCONFIGURED: '__UNCONFIGURED__' };

const getRules = state => (state.service.timeslot || {}).rules || [];

const getExports = state => (state.exports && state.exports.list) || [];

// Ensemble { [id_product]: true } des produits présents dans au moins un export
// (toutes sections, tous partenaires confondus). Sert à filtrer la liste centrale.
export const getExportProductIds = createSelector([getExports], exports => {
	const set = {};
	exports.forEach(exp => {
		(exp.sections || []).forEach(section => {
			(section.products || []).forEach(product => {
				if (product && product.id_product != null) {
					set[String(product.id_product)] = true;
				}
			});
		});
	});
	return set;
});

// Map { [idProduct]: { enable, disable, total } }.
// Un produit est « configuré » dès qu'il a total > 0.
// On ignore les règles section (idProduct null) : elles sont gérées côté back.
export const getConfiguredByProduct = createSelector([getRules], rules => {
	const map = {};
	rules.forEach(rule => {
		if (rule.idProduct == null) return;
		const key = String(rule.idProduct);
		if (!map[key]) map[key] = { enable: 0, disable: 0, total: 0 };
		if (rule.rule === 'disable') {
			map[key].disable += 1;
		} else {
			map[key].enable += 1;
		}
		map[key].total += 1;
	});
	return map;
});

// Index plat { [idProduct]: { id, name, id_menu } } pour résoudre un produit
// (nom + menu) depuis une règle, quel que soit son menu d'origine.
export const getFlatProducts = createSelector([getProductsList], list => {
	const flat = {};
	Object.keys(list).forEach(idMenu => {
		const byMenu = list[idMenu] || {};
		Object.values(byMenu).forEach(product => {
			if (product && product.id != null) {
				flat[String(product.id)] = {
					id: product.id,
					name: product.name,
					id_menu: idMenu,
				};
			}
		});
	});
	return flat;
});

// Compteurs de produits par catégorie POUR LE MENU COURANT, incluant les
// entrées spéciales (ALL, 0 = sans catégorie, pseudo-catégories). Alimente les
// badges de la colonne gauche.
export const getCategoryCounts = createSelector(
	[
		getProductsList,
		getMenuSelected,
		getConfiguredByProduct,
		getExportProductIds,
	],
	(products, menuSelected, configured, exportIds) => {
		const byMenu = products[menuSelected] || {};
		const items = Object.values(byMenu).filter(p => p && p.type !== 'menu');
		const counts = {
			[ALL]: 0,
			0: 0,
			[PSEUDO.EXPORTS]: 0,
			[PSEUDO.UNCONFIGURED]: 0,
		};
		items.forEach(p => {
			counts[ALL] += 1;
			const cats = p.categories || [];
			if (!cats.length) {
				counts[0] += 1;
			}
			cats.forEach(c => {
				const key = String(c);
				counts[key] = (counts[key] || 0) + 1;
			});
			if (exportIds[String(p.id)]) {
				counts[PSEUDO.EXPORTS] += 1;
			}
			if (!configured[String(p.id)]) {
				counts[PSEUDO.UNCONFIGURED] += 1;
			}
		});
		return counts;
	}
);
